import { ProgressProps } from '@ui-components/neo.tax';

import { FormAlertCard } from './FormAlertCard';

type FormProgressAlertCardProps = {
  progress: Record<string, ProgressProps>;
  analyticId?: string;
};

export const FormProgressAlertCard = ({ analyticId, progress }: FormProgressAlertCardProps): React.ReactElement => {
  const entireProgress = Object.entries(progress)
    .map(([key, progress]) => {
      const remaining = progress.total - progress.completed;
      if (!remaining) return null;
      return (
        <div key={key}>
          <strong>{remaining}</strong> remaining in <strong>{key}</strong>
        </div>
      );
    })
    .filter(Boolean);

  if (!entireProgress.length) {
    return <></>;
  }

  return (
    <FormAlertCard id={analyticId} severity="warning" title="Attention needed, you have:" subtitle={entireProgress} />
  );
};
